import { render, staticRenderFns } from "./VAppFooter.vue?vue&type=template&id=6e842a92&"
import script from "./VAppFooter.vue?vue&type=script&lang=ts&"
export * from "./VAppFooter.vue?vue&type=script&lang=ts&"
import style0 from "./VAppFooter.vue?vue&type=style&index=0&id=6e842a92&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports